import { reactive, onActivated } from 'vue'
import { useStore } from '@/store'

export default function(dataMap: any) {
  // 高性能修复：从缓存(keep-alive)恢复时，通知 grid-layout 重新计算宽度，而不是全局监听路由
  onActivated(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 100)
  })


  const mixinData = reactive({
    rowHeight: 40,
    isFilterCollapse: false,
    isSubMenuCollapse: true,
    menuHeight: 10,
    menuHeightPx: 0,
    filterContainerH: 0,
    containerHeight: 0,
    layouts: [
      { x: 0, y: 0, w: 12, h: 12, i: '0', maxW: 12, minW: 12, minH: 1, height: 0, static: false },
      { x: 0, y: 0, w: 12, h: 3, i: '1', maxW: 12, minW: 12, minH: 1, height: 0, static: true }
    ],
    handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
      mixinData.layouts[0].h = newH
      mixinData.layouts[0].height = newHPx
      dataMap.newHpx = newHPx
      mixinData.layouts[1].y = newH + 1
    },
    containerResizedEvent(hpx: any, h: any) {
      mixinData.containerHeight = hpx
      mixinData.layouts[1].y = h + 1
    },
    handleSubMenuCollapse() {
      const { fullHeight, rowH } = mixinData.getFullHeight()
      const { h, height } = mixinData.layouts[0]
      if (!mixinData.isSubMenuCollapse) { // false收起
        // 点击收起记录table高度，且铺开显示table
        mixinData.menuHeight = h
        mixinData.menuHeightPx = height

        mixinData.containerResizedEvent(fullHeight, h)
        mixinData.handleResizedEvent('', rowH, '', fullHeight)
        console.log('layouts', rowH)
      } else { // true展开
        if (!height) { // 第一次没拖拽展开高度为固定高度
          mixinData.menuHeight = h - 3
          mixinData.menuHeightPx = fullHeight - 3 * 40
        } else if (height !== fullHeight) { // 拖拽过就用拖拽高度
          mixinData.menuHeight = h
          mixinData.menuHeightPx = height
        }
        mixinData.containerResizedEvent(mixinData.menuHeightPx, mixinData.menuHeight)
        mixinData.handleResizedEvent('', mixinData.menuHeight, '', mixinData.menuHeightPx)
      }
      mixinData.isSubMenuCollapse = !mixinData.isSubMenuCollapse
    },
    getFullHeight() { // 根据屏幕适配初始化高度
      const appMainHeight = document.querySelector('.app-main')?.clientHeight || 0
      const filterContainerH = document.querySelector('.filter-container')?.clientHeight || 0
      const fullHeight = appMainHeight - filterContainerH - 70
      const rowH = Math.floor(fullHeight / 50)
      // console.log(appMainHeight, 'appMainHeight', filterContainerH, rowH)

      return {
        fullHeight,
        rowH
      }
    },
    initHeight() {
      const { layouts } = mixinData
      if (!layouts) {
        return
      }
      // 有grid item
      const { rowH } = mixinData.getFullHeight()
      layouts[0].h = rowH
      // 有子table的grid item
      if (layouts.length > 1) {
        layouts[1].y = rowH + 1
      }
    },
    hasPremiessionBtnList(btnCodes: any) {
      const permissionsBtn = useStore().state.permission.permissionsBtn
      return btnCodes.filter((item: any) => {
        return permissionsBtn.find(kk => kk.icon === item.pkey)
      })
    }
  })
  return { mixinData }
}
